import { H4 } from "@dgs/core";
import { FC, useId } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

interface Props {
	error?: string | false;
	travelsCount: number;
	maxTravels: number | null;
}

const InlineH4 = styled(H4)`
	display: inline;
`;

const Error = styled.div`
	${({ theme }) => theme.forms.error};
`;

export const RegistrationTravelSectionTitle: FC<Props> = ({ error, maxTravels, travelsCount }) => {
	const { t } = useTranslation();
	const errorId = useId();

	return (
		<div aria-invalid={!!error} aria-errormessage={error ? errorId : undefined}>
			<InlineH4>{t("Travel planning")}</InlineH4>{" "}
			{maxTravels !== null && (
				<>
					(
					{t("{{count}} of {{max}}", {
						count: travelsCount,
						max: maxTravels,
					})}
					)
				</>
			)}
			{error && <Error id={errorId}>{error}</Error>}
		</div>
	);
};
